import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=70e10536&"
import script from "./GlobalAlert.vue?vue&type=script&lang=ts&"
export * from "./GlobalAlert.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalAlert.vue?vue&type=style&index=0&id=70e10536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports